import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "stage-title-wr" }
const _hoisted_3 = { class: "stage-title" }
const _hoisted_4 = { class: "stage-info" }
const _hoisted_5 = { class: "table-scroll" }
const _hoisted_6 = { class: "table-default" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "lot-number" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "action" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 2,
  class: "list-view-mobile"
}
const _hoisted_15 = {
  key: 0,
  class: "lot-img"
}
const _hoisted_16 = { class: "lot-img-title" }
const _hoisted_17 = ["viewBox"]
const _hoisted_18 = ["d"]
const _hoisted_19 = { class: "title-and-status" }
const _hoisted_20 = {
  key: 0,
  class: "lot-title"
}
const _hoisted_21 = { class: "first-block" }
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "value" }
const _hoisted_25 = { class: "second-block" }
const _hoisted_26 = { class: "value" }
const _hoisted_27 = { class: "value" }
const _hoisted_28 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!$setup.loading)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["map-wr", { isMapModalView: $setup.props.isMapModalView }])
      }, [
        (!$setup.isDesktop && !$setup.props.hideNav)
          ? (_openBlock(), _createBlock($setup["StageNavMobile"], {
              key: 0,
              estateId: $setup.estateId,
              viewType: $props.viewType,
              mapPage: $setup.props.mapPage,
              isEmbedded: $setup.props.isEmbedded,
              isBuilderView: $setup.props.isBuilderView,
              isMapModalView: $setup.props.isMapModalView,
              onChangeView: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('changeView')))
            }, null, 8, ["estateId", "viewType", "mapPage", "isEmbedded", "isBuilderView", "isMapModalView"]))
          : _createCommentVNode("", true),
        (!$props.isBuilderView)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["lots-title", { 'lots-title-mobile': !$setup.isDesktop, hidden: $setup.props.hideStageRowHeader }])
            }, _toDisplayString($setup.plural($setup.getNumberOfLots, "lot")), 3))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lotsList, (stage, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "stage-row-wrapper",
            key: index
          }, [
            _createElementVNode("div", {
              class: "stage-block",
              onClick: ($event: any) => ($setup.onLotRow(index))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["stage-row", { hidden: $setup.props.hideStageRowHeader, 'builder-style': $setup.props.isBuilderView && $setup.isDesktop, borders: $setup.props.isMapModalView }])
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createTextVNode("Stage " + _toDisplayString(stage.stage.title), 1),
                    _createElementVNode("div", _hoisted_4, _toDisplayString($setup.getStageTitle(index, $props.isBuilderView)), 1)
                  ]),
                  (stage.lotData.length > 0)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["chevron", { rotated: !$setup.activeStagesIndex[index] }])
                      }, null, 2))
                    : _createCommentVNode("", true)
                ])
              ], 2)
            ], 8, _hoisted_1),
            _createElementVNode("div", {
              class: _normalizeClass(["wrapper-table", { opened: $setup.activeStagesIndex[index] }]),
              ref_for: true,
              ref: (el) => { if (el) { $setup.tableRefs[index] = el; } }
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("table", _hoisted_6, [
                  ($setup.isDesktop)
                    ? (_openBlock(), _createElementBlock("thead", _hoisted_7, [
                        _createElementVNode("tr", null, [
                          _cache[1] || (_cache[1] = _createElementVNode("th", null, "Lot No.", -1)),
                          _cache[2] || (_cache[2] = _createElementVNode("th", null, "Size (m2)", -1)),
                          _createElementVNode("th", null, _toDisplayString($props.isBuilderView ? "Width" : "Width (m)"), 1),
                          (!$props.estate.hidePrice)
                            ? (_openBlock(), _createElementBlock("th", _hoisted_8, "Price"))
                            : _createCommentVNode("", true),
                          _cache[3] || (_cache[3] = _createElementVNode("th", null, "Est. Registration", -1)),
                          _cache[4] || (_cache[4] = _createElementVNode("th", null, "Status", -1)),
                          _cache[5] || (_cache[5] = _createElementVNode("th", null, null, -1))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.isDesktop)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredLotData(stage.lotData), (lot, idx) => {
                          return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                            _createElementVNode("td", _hoisted_10, "Lot " + _toDisplayString(lot.lotId.title), 1),
                            _createElementVNode("td", null, _toDisplayString(lot.lotId.size), 1),
                            _createElementVNode("td", null, _toDisplayString(lot.lotId?.blockWidth ? lot.lotId.blockWidth : "Irregular"), 1),
                            (!$props.estate.hidePrice)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_11, _toDisplayString($setup.formatPrice(lot.lotId.price)), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("td", null, _toDisplayString(lot.lotId?.registrationDate ? $setup.formatDate(lot.lotId.registrationDate, "MMM YYYY") : "-"), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["badge", { 'badge-builder': $setup.props.isBuilderView, [$setup.getLotCustomerMapStatusClass($setup.getLotStatus(lot.lotId.status === $setup.LotStatus.OFFLINE ? lot.lotId?.offlineSale?.salePhase : lot.lotId.status))]: true }])
                              }, _toDisplayString($setup.getLotStatus(lot.lotId.status === $setup.LotStatus.OFFLINE? lot.lotId?.offlineSale?.salePhase
: lot.lotId.status)), 3)
                            ]),
                            _createElementVNode("td", _hoisted_12, [
                              (lot.lotId.status === $setup.LotStatus.AVAILABLE)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: _normalizeClass(["button default primary", { 'color-button-builder': $props.isBuilderView }]),
                                    onClick: ($event: any) => ($setup.onStageClick(stage.stage, lot))
                                  }, _toDisplayString($props.isBuilderView ? "Select lot" : "View lot"), 11, _hoisted_13))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("tbody", _hoisted_14, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredLotData(stage.lotData), (lot, idx) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: idx,
                            class: _normalizeClass({ 'my-1': $setup.props.hideStageRowHeader })
                          }, [
                            _createElementVNode("td", {
                              class: _normalizeClass(["card-container", { 'card-border-top': $props.hideStageRowHeader }])
                            }, [
                              (!$setup.props.isMapModalView)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, "Lot " + _toDisplayString(lot.lotId.title), 1),
                                    (_openBlock(), _createElementBlock("svg", {
                                      class: "item-wr svg-img",
                                      xmlns: "http://www.w3.org/2000/svg",
                                      "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                      version: "1.1",
                                      viewBox: `0 0 ${lot.size.width} ${lot.size.height}`
                                    }, [
                                      _createElementVNode("path", {
                                        class: "item-path",
                                        d: $setup.getLotPath(lot.path)
                                      }, null, 8, _hoisted_18)
                                    ], 8, _hoisted_17))
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", {
                                class: _normalizeClass(["card-wrapper", { padding: $setup.props.isMapModalView }])
                              }, [
                                _createElementVNode("div", _hoisted_19, [
                                  ($setup.props.isMapModalView)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Lot " + _toDisplayString(lot.lotId.title), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["badge", $setup.getLotCustomerMapStatusClass($setup.getLotStatus(lot.lotId.status === $setup.LotStatus.OFFLINE ? lot.lotId?.offlineSale?.salePhase : lot.lotId.status))])
                                  }, _toDisplayString($setup.getLotStatus(lot.lotId.status === $setup.LotStatus.OFFLINE? lot.lotId?.offlineSale?.salePhase
: lot.lotId.status)), 3)
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["content", { 'content-row': $props.estate.hidePrice }])
                                }, [
                                  _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("div", null, [
                                      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "subtitle-main" }, "Size", -1)),
                                      _createElementVNode("span", _hoisted_22, _toDisplayString(lot.lotId.size), 1)
                                    ]),
                                    (!$props.estate.hidePrice)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "subtitle-main" }, "Price", -1)),
                                          _createElementVNode("span", _hoisted_24, _toDisplayString($setup.formatPrice(lot.lotId.price)), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_25, [
                                    _createElementVNode("div", null, [
                                      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "subtitle-main" }, "Width", -1)),
                                      _createElementVNode("span", _hoisted_26, _toDisplayString(lot.lotId?.blockWidth ? lot.lotId.blockWidth : "-"), 1)
                                    ]),
                                    _createElementVNode("div", null, [
                                      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "subtitle-main" }, "Registration", -1)),
                                      _createElementVNode("span", _hoisted_27, _toDisplayString(lot.lotId?.registrationDate ? $setup.formatDate(lot.lotId.registrationDate, "MMM YYYY") : "-"), 1)
                                    ])
                                  ])
                                ], 2),
                                (lot.lotId.status === $setup.LotStatus.AVAILABLE)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: _normalizeClass(["button default primary btn-mobile", { 'color-button-builder': $props.isBuilderView }]),
                                      id: "btn-mobile",
                                      onClick: ($event: any) => ($setup.onStageClick(stage.stage, lot))
                                    }, _toDisplayString($props.isBuilderView ? "Select lot" : "View lot"), 11, _hoisted_28))
                                  : _createCommentVNode("", true)
                              ], 2)
                            ], 2)
                          ], 2))
                        }), 128))
                      ]))
                ])
              ])
            ], 2)
          ]))
        }), 128))
      ], 2))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["spinner", { 'color-builder': $props.isBuilderView }])
      }, null, 2))
}